import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ChangeWorkOrderQuantityProducedMutationVariables = Types.Exact<{
  input: Types.ChangeWorkOrderQuantityProducedInput;
}>;


export type ChangeWorkOrderQuantityProducedMutation = { __typename?: 'Mutation', changeWorkOrderQuantityProduced: { __typename?: 'JobPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, job?: { __typename?: 'JobData', containerQuantity: number, created: Types.TDateISO, deliveryDate: Types.TDateISO, erpId: string, id: string, jobStatus: Types.JobStatus, jobType: Types.JobType, locationId: string, name: string, productionQuantity: number, startDate: Types.TDateISO, tenantId: string, unitOfMeasure: string, updated: Types.TDateISO, item: { __typename?: 'JobItem', created: Types.TDateISO, erpId: string, genusCode: string, id: string, itemId: string, name: string, upc: string, updated: Types.TDateISO }, workOrders: Array<{ __typename?: 'WorkOrderData', containerQuantity: number, created: Types.TDateISO, deliveryDate: Types.TDateISO, erpId: string, id: string, jobId: string, lineNumber: number, productionQuantity: number, quantityProduced: number, startDate: Types.TDateISO, tenantId: string, updated: Types.TDateISO, workOrderStatus: Types.WorkOrderStatus }> } | null } };

export type ChangeWorkOrderStatusMutationVariables = Types.Exact<{
  input: Types.ChangeWorkOrderStatusInput;
}>;


export type ChangeWorkOrderStatusMutation = { __typename?: 'Mutation', changeWorkOrderStatus: { __typename?: 'JobPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, job?: { __typename?: 'JobData', containerQuantity: number, created: Types.TDateISO, deliveryDate: Types.TDateISO, erpId: string, id: string, jobStatus: Types.JobStatus, jobType: Types.JobType, locationId: string, name: string, productionQuantity: number, startDate: Types.TDateISO, tenantId: string, unitOfMeasure: string, updated: Types.TDateISO, workOrders: Array<{ __typename?: 'WorkOrderData', containerQuantity: number, created: Types.TDateISO, deliveryDate: Types.TDateISO, erpId: string, id: string, jobId: string, lineNumber: number, productionQuantity: number, quantityProduced: number, startDate: Types.TDateISO, tenantId: string, updated: Types.TDateISO, workOrderStatus: Types.WorkOrderStatus }>, item: { __typename?: 'JobItem', created: Types.TDateISO, erpId: string, genusCode: string, id: string, itemId: string, name: string, upc: string, updated: Types.TDateISO } } | null } };

export type CountMaterialItemMutationVariables = Types.Exact<{
  input: Types.CountMaterialItemInput;
}>;


export type CountMaterialItemMutation = { __typename?: 'Mutation', countMaterialItem: { __typename: 'MaterialItemLocationQuantityPayload', materialItemLocationQuantity?: Array<{ __typename?: 'MaterialItemLocationQuantityDocument', id: string, locationId: string, materialItemId: string, quantity: number, tenantId: string, updated: Types.TDateISO }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MoveMaterialItemMutationVariables = Types.Exact<{
  input: Types.MoveMaterialItemInput;
}>;


export type MoveMaterialItemMutation = { __typename?: 'Mutation', moveMaterialItem: { __typename: 'MaterialItemLocationQuantityPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, materialItemLocationQuantity?: Array<{ __typename?: 'MaterialItemLocationQuantityDocument', id: string, locationId: string, materialItemId: string, quantity: number, tenantId: string, updated: Types.TDateISO }> | null } };

export type AdjustMaterialItemMutationVariables = Types.Exact<{
  input: Types.AdjustMaterialItemInput;
}>;


export type AdjustMaterialItemMutation = { __typename?: 'Mutation', adjustMaterialItem: { __typename: 'MaterialItemLocationQuantityPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, materialItemLocationQuantity?: Array<{ __typename?: 'MaterialItemLocationQuantityDocument', id: string, locationId: string, materialItemId: string, quantity: number, tenantId: string, updated: Types.TDateISO }> | null } };

export type CreateMaterialItemMutationVariables = Types.Exact<{
  input: Types.CreateMaterialItemInput;
}>;


export type CreateMaterialItemMutation = { __typename?: 'Mutation', createMaterialItem: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateMaterialItemDetailsMutationVariables = Types.Exact<{
  input: Types.UpdateMaterialItemDetailsInput;
}>;


export type UpdateMaterialItemDetailsMutation = { __typename?: 'Mutation', updateMaterialItemDetails: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateTagMutationVariables = Types.Exact<{
  input: Types.CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', erpId: string, id: string, quantityOnHand?: number | null, status: Types.MaterialItemStatus, updated: Types.TDateISO, tag?: { __typename?: 'MaterialItemTagData', category?: string | null, color?: string | null, customerName?: string | null, description?: string | null, extraCodes: Array<string>, fulfillItemCode?: string | null, genus?: string | null, retail?: number | null, series?: string | null, source: Types.ProduceTagSource, sku?: string | null, tagCode: string, tagId?: string | null, tagType?: string | null, upc?: string | null, volume?: string | null, weekFrom?: number | null, weekTo?: number | null, year?: number | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetMaterialItemTagSpecMutationVariables = Types.Exact<{
  input: Types.SetMaterialItemTagSpecInput;
}>;


export type SetMaterialItemTagSpecMutation = { __typename?: 'Mutation', setMaterialItemTagSpec: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', erpId: string, id: string, quantityOnHand?: number | null, status: Types.MaterialItemStatus, updated: Types.TDateISO, tag?: { __typename?: 'MaterialItemTagData', category?: string | null, color?: string | null, customerName?: string | null, description?: string | null, extraCodes: Array<string>, fulfillItemCode?: string | null, genus?: string | null, retail?: number | null, series?: string | null, source: Types.ProduceTagSource, sku?: string | null, tagCode: string, tagId?: string | null, tagType?: string | null, upc?: string | null, volume?: string | null, weekFrom?: number | null, weekTo?: number | null, year?: number | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateOrUpdateTagByTagCodeMutationVariables = Types.Exact<{
  input: Types.CreateOrUpdateTagByTagCodeInput;
}>;


export type CreateOrUpdateTagByTagCodeMutation = { __typename?: 'Mutation', createOrUpdateTagByTagCode: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', erpId: string, id: string, quantityOnHand?: number | null, status: Types.MaterialItemStatus, updated: Types.TDateISO, tag?: { __typename?: 'MaterialItemTagData', category?: string | null, color?: string | null, customerName?: string | null, description?: string | null, extraCodes: Array<string>, fulfillItemCode?: string | null, genus?: string | null, retail?: number | null, series?: string | null, source: Types.ProduceTagSource, sku?: string | null, tagCode: string, tagId?: string | null, tagType?: string | null, upc?: string | null, volume?: string | null, weekFrom?: number | null, weekTo?: number | null, year?: number | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateMaterialItemMutationVariables = Types.Exact<{
  input: Types.ActivateMaterialItemInput;
}>;


export type ActivateMaterialItemMutation = { __typename?: 'Mutation', activateMaterialItem: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateMaterialItemMutationVariables = Types.Exact<{
  input: Types.InactivateMaterialItemInput;
}>;


export type InactivateMaterialItemMutation = { __typename?: 'Mutation', inactivateMaterialItem: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteMaterialItemMutationVariables = Types.Exact<{
  input: Types.DeleteMaterialItemInput;
}>;


export type DeleteMaterialItemMutation = { __typename?: 'Mutation', deleteMaterialItem: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UndeleteMaterialItemMutationVariables = Types.Exact<{
  input: Types.UndeleteMaterialItemInput;
}>;


export type UndeleteMaterialItemMutation = { __typename?: 'Mutation', undeleteMaterialItem: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignMaterialItemToVendorMutationVariables = Types.Exact<{
  input: Types.AssignMaterialItemToVendorInput;
}>;


export type AssignMaterialItemToVendorMutation = { __typename?: 'Mutation', assignMaterialItemToVendor: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnassignMaterialItemToVendorMutationVariables = Types.Exact<{
  input: Types.UnassignMaterialItemToVendorInput;
}>;


export type UnassignMaterialItemToVendorMutation = { __typename?: 'Mutation', unassignMaterialItemToVendor: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetDefaultVendorMutationVariables = Types.Exact<{
  input: Types.SetDefaultVendorInput;
}>;


export type SetDefaultVendorMutation = { __typename?: 'Mutation', setDefaultVendor: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetVendorMaterialCostMutationVariables = Types.Exact<{
  input: Types.SetVendorMaterialCostInput;
}>;


export type SetVendorMaterialCostMutation = { __typename?: 'Mutation', setVendorMaterialCost: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateCountAssignmentMutationVariables = Types.Exact<{
  input: Types.CreateCountAssignmentInput;
}>;


export type CreateCountAssignmentMutation = { __typename?: 'Mutation', createCountAssignment: { __typename?: 'CycleCountAssignmentPayload', cycleCountAssignment?: { __typename?: 'CycleCountAssignmentStateData', assignmentId: string, status: Types.CycleCountAssignmentStatus, workerUserId?: string | null, tasks: Array<{ __typename?: 'CycleCountAssignmentTaskStateData', taskId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReassignCountAssignmentMutationVariables = Types.Exact<{
  input: Types.ReassignCountAssignmentInput;
}>;


export type ReassignCountAssignmentMutation = { __typename?: 'Mutation', reassignCountAssignment: { __typename?: 'CycleCountAssignmentPayload', cycleCountAssignment?: { __typename?: 'CycleCountAssignmentStateData', assignmentId: string, status: Types.CycleCountAssignmentStatus, workerUserId?: string | null, tasks: Array<{ __typename?: 'CycleCountAssignmentTaskStateData', taskId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnassignCountAssignmentMutationVariables = Types.Exact<{
  input: Types.UnassignCountAssignmentInput;
}>;


export type UnassignCountAssignmentMutation = { __typename?: 'Mutation', unassignCountAssignment: { __typename?: 'CycleCountAssignmentPayload', cycleCountAssignment?: { __typename?: 'CycleCountAssignmentStateData', assignmentId: string, status: Types.CycleCountAssignmentStatus, workerUserId?: string | null, tasks: Array<{ __typename?: 'CycleCountAssignmentTaskStateData', taskId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StartAssignmentTaskMutationVariables = Types.Exact<{
  input: Types.StartAssignmentTaskInput;
}>;


export type StartAssignmentTaskMutation = { __typename?: 'Mutation', startAssignmentTask: { __typename?: 'CycleCountAssignmentPayload', cycleCountAssignment?: { __typename?: 'CycleCountAssignmentStateData', assignmentId: string, status: Types.CycleCountAssignmentStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteAssignmentTaskMutationVariables = Types.Exact<{
  input: Types.CompleteAssignmentTaskInput;
}>;


export type CompleteAssignmentTaskMutation = { __typename?: 'Mutation', completeAssignmentTask: { __typename?: 'CycleCountAssignmentPayload', cycleCountAssignment?: { __typename?: 'CycleCountAssignmentStateData', assignmentId: string, status: Types.CycleCountAssignmentStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SkipAssignmentTaskMutationVariables = Types.Exact<{
  input: Types.SkipAssignmentTaskInput;
}>;


export type SkipAssignmentTaskMutation = { __typename?: 'Mutation', skipAssignmentTask: { __typename?: 'CycleCountAssignmentPayload', cycleCountAssignment?: { __typename?: 'CycleCountAssignmentStateData', assignmentId: string, status: Types.CycleCountAssignmentStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetMaterialItemBatchTrackingMutationVariables = Types.Exact<{
  input: Types.SetMaterialItemBatchTrackingInput;
}>;


export type SetMaterialItemBatchTrackingMutation = { __typename?: 'Mutation', setMaterialItemBatchTracking: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetMaterialItemImageMutationVariables = Types.Exact<{
  input: Types.SetMaterialItemImageInput;
}>;


export type SetMaterialItemImageMutation = { __typename?: 'Mutation', setMaterialItemImage: { __typename?: 'MaterialItemPayload', materialItem?: { __typename?: 'MaterialItemDocument', accountingId?: string | null, batchTracked: boolean, category: string, created: Types.TDateISO, description: string, erpId: string, id: string, isOrganic: boolean, itemType?: string | null, name: string, purchasingRevision: number, sellable: boolean, status: Types.MaterialItemStatus, tenantId: string, updated: Types.TDateISO, materialImage?: { __typename?: 'MaterialImageData', image: string, imageUrl?: string | null, mime: string } | null, vendors: Array<{ __typename?: 'MaterialVendorData', vendorId: string, vendorName: string, vendorItemId?: string | null, isDefault: boolean, purchaseUom?: string | null, unitsPerUom?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const ChangeWorkOrderQuantityProducedDocument = new TypedDocumentString(`
    mutation ChangeWorkOrderQuantityProduced($input: ChangeWorkOrderQuantityProducedInput!) {
  changeWorkOrderQuantityProduced(input: $input) {
    errors {
      code
      message
    }
    job {
      containerQuantity
      created
      deliveryDate
      erpId
      id
      jobStatus
      jobType
      locationId
      name
      productionQuantity
      startDate
      tenantId
      unitOfMeasure
      updated
      item {
        created
        erpId
        genusCode
        id
        itemId
        name
        upc
        updated
      }
      workOrders {
        containerQuantity
        created
        deliveryDate
        erpId
        id
        jobId
        lineNumber
        productionQuantity
        quantityProduced
        startDate
        tenantId
        updated
        workOrderStatus
      }
    }
  }
}
    `);
export const ChangeWorkOrderStatusDocument = new TypedDocumentString(`
    mutation ChangeWorkOrderStatus($input: ChangeWorkOrderStatusInput!) {
  changeWorkOrderStatus(input: $input) {
    errors {
      code
      message
    }
    job {
      containerQuantity
      created
      deliveryDate
      erpId
      id
      jobStatus
      jobType
      locationId
      name
      productionQuantity
      startDate
      tenantId
      unitOfMeasure
      updated
      workOrders {
        containerQuantity
        created
        deliveryDate
        erpId
        id
        jobId
        lineNumber
        productionQuantity
        quantityProduced
        startDate
        tenantId
        updated
        workOrderStatus
      }
      item {
        created
        erpId
        genusCode
        id
        itemId
        name
        upc
        updated
      }
    }
  }
}
    `);
export const CountMaterialItemDocument = new TypedDocumentString(`
    mutation CountMaterialItem($input: CountMaterialItemInput!) {
  countMaterialItem(input: $input) {
    materialItemLocationQuantity {
      id
      locationId
      materialItemId
      quantity
      tenantId
      updated
    }
    errors {
      code
      message
    }
    __typename
  }
}
    `);
export const MoveMaterialItemDocument = new TypedDocumentString(`
    mutation MoveMaterialItem($input: MoveMaterialItemInput!) {
  moveMaterialItem(input: $input) {
    errors {
      code
      message
    }
    materialItemLocationQuantity {
      id
      locationId
      materialItemId
      quantity
      tenantId
      updated
    }
    __typename
  }
}
    `);
export const AdjustMaterialItemDocument = new TypedDocumentString(`
    mutation AdjustMaterialItem($input: AdjustMaterialItemInput!) {
  adjustMaterialItem(input: $input) {
    errors {
      code
      message
    }
    materialItemLocationQuantity {
      id
      locationId
      materialItemId
      quantity
      tenantId
      updated
    }
    __typename
  }
}
    `);
export const CreateMaterialItemDocument = new TypedDocumentString(`
    mutation CreateMaterialItem($input: CreateMaterialItemInput!) {
  createMaterialItem(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const UpdateMaterialItemDetailsDocument = new TypedDocumentString(`
    mutation UpdateMaterialItemDetails($input: UpdateMaterialItemDetailsInput!) {
  updateMaterialItemDetails(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const CreateTagDocument = new TypedDocumentString(`
    mutation CreateTag($input: CreateTagInput!) {
  createTag(input: $input) {
    materialItem {
      ...ProduceTag
    }
    errors {
      code
      message
    }
  }
}
    fragment ProduceTag on MaterialItemDocument {
  erpId
  id
  quantityOnHand
  status
  tag {
    category
    color
    customerName
    description
    extraCodes
    fulfillItemCode
    genus
    retail
    series
    source
    sku
    tagCode
    tagId
    tagType
    upc
    volume
    weekFrom
    weekTo
    year
  }
  updated
}`);
export const SetMaterialItemTagSpecDocument = new TypedDocumentString(`
    mutation SetMaterialItemTagSpec($input: SetMaterialItemTagSpecInput!) {
  setMaterialItemTagSpec(input: $input) {
    materialItem {
      ...ProduceTag
    }
    errors {
      code
      message
    }
  }
}
    fragment ProduceTag on MaterialItemDocument {
  erpId
  id
  quantityOnHand
  status
  tag {
    category
    color
    customerName
    description
    extraCodes
    fulfillItemCode
    genus
    retail
    series
    source
    sku
    tagCode
    tagId
    tagType
    upc
    volume
    weekFrom
    weekTo
    year
  }
  updated
}`);
export const CreateOrUpdateTagByTagCodeDocument = new TypedDocumentString(`
    mutation CreateOrUpdateTagByTagCode($input: CreateOrUpdateTagByTagCodeInput!) {
  createOrUpdateTagByTagCode(input: $input) {
    materialItem {
      ...ProduceTag
    }
    errors {
      code
      message
    }
  }
}
    fragment ProduceTag on MaterialItemDocument {
  erpId
  id
  quantityOnHand
  status
  tag {
    category
    color
    customerName
    description
    extraCodes
    fulfillItemCode
    genus
    retail
    series
    source
    sku
    tagCode
    tagId
    tagType
    upc
    volume
    weekFrom
    weekTo
    year
  }
  updated
}`);
export const ActivateMaterialItemDocument = new TypedDocumentString(`
    mutation ActivateMaterialItem($input: ActivateMaterialItemInput!) {
  activateMaterialItem(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const InactivateMaterialItemDocument = new TypedDocumentString(`
    mutation InactivateMaterialItem($input: InactivateMaterialItemInput!) {
  inactivateMaterialItem(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const DeleteMaterialItemDocument = new TypedDocumentString(`
    mutation DeleteMaterialItem($input: DeleteMaterialItemInput!) {
  deleteMaterialItem(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const UndeleteMaterialItemDocument = new TypedDocumentString(`
    mutation UndeleteMaterialItem($input: UndeleteMaterialItemInput!) {
  undeleteMaterialItem(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const AssignMaterialItemToVendorDocument = new TypedDocumentString(`
    mutation AssignMaterialItemToVendor($input: AssignMaterialItemToVendorInput!) {
  assignMaterialItemToVendor(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const UnassignMaterialItemToVendorDocument = new TypedDocumentString(`
    mutation UnassignMaterialItemToVendor($input: UnassignMaterialItemToVendorInput!) {
  unassignMaterialItemToVendor(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const SetDefaultVendorDocument = new TypedDocumentString(`
    mutation SetDefaultVendor($input: SetDefaultVendorInput!) {
  setDefaultVendor(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const SetVendorMaterialCostDocument = new TypedDocumentString(`
    mutation SetVendorMaterialCost($input: SetVendorMaterialCostInput!) {
  setVendorMaterialCost(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const CreateCountAssignmentDocument = new TypedDocumentString(`
    mutation CreateCountAssignment($input: CreateCountAssignmentInput!) {
  createCountAssignment(input: $input) {
    cycleCountAssignment {
      ...CycleCountAssignmentFields
    }
    errors {
      code
      message
    }
  }
}
    fragment CycleCountAssignmentFields on CycleCountAssignmentStateData {
  assignmentId
  status
  workerUserId
  tasks {
    taskId
  }
}`);
export const ReassignCountAssignmentDocument = new TypedDocumentString(`
    mutation ReassignCountAssignment($input: ReassignCountAssignmentInput!) {
  reassignCountAssignment(input: $input) {
    cycleCountAssignment {
      ...CycleCountAssignmentFields
    }
    errors {
      code
      message
    }
  }
}
    fragment CycleCountAssignmentFields on CycleCountAssignmentStateData {
  assignmentId
  status
  workerUserId
  tasks {
    taskId
  }
}`);
export const UnassignCountAssignmentDocument = new TypedDocumentString(`
    mutation UnassignCountAssignment($input: UnassignCountAssignmentInput!) {
  unassignCountAssignment(input: $input) {
    cycleCountAssignment {
      ...CycleCountAssignmentFields
    }
    errors {
      code
      message
    }
  }
}
    fragment CycleCountAssignmentFields on CycleCountAssignmentStateData {
  assignmentId
  status
  workerUserId
  tasks {
    taskId
  }
}`);
export const StartAssignmentTaskDocument = new TypedDocumentString(`
    mutation StartAssignmentTask($input: StartAssignmentTaskInput!) {
  startAssignmentTask(input: $input) {
    cycleCountAssignment {
      assignmentId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const CompleteAssignmentTaskDocument = new TypedDocumentString(`
    mutation CompleteAssignmentTask($input: CompleteAssignmentTaskInput!) {
  completeAssignmentTask(input: $input) {
    cycleCountAssignment {
      assignmentId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SkipAssignmentTaskDocument = new TypedDocumentString(`
    mutation SkipAssignmentTask($input: SkipAssignmentTaskInput!) {
  skipAssignmentTask(input: $input) {
    cycleCountAssignment {
      assignmentId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SetMaterialItemBatchTrackingDocument = new TypedDocumentString(`
    mutation SetMaterialItemBatchTracking($input: SetMaterialItemBatchTrackingInput!) {
  setMaterialItemBatchTracking(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
export const SetMaterialItemImageDocument = new TypedDocumentString(`
    mutation SetMaterialItemImage($input: SetMaterialItemImageInput!) {
  setMaterialItemImage(input: $input) {
    materialItem {
      ...MaterialItem
    }
    errors {
      code
      message
    }
  }
}
    fragment MaterialItem on MaterialItemDocument {
  accountingId
  batchTracked
  category
  created
  description
  erpId
  id
  isOrganic
  itemType
  materialImage {
    image
    imageUrl
    mime
  }
  name
  purchasingRevision
  sellable
  status
  tenantId
  updated
  vendors {
    vendorId
    vendorName
    vendorItemId
    isDefault
    purchaseUom
    unitsPerUom
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    ChangeWorkOrderQuantityProduced: build.mutation<ChangeWorkOrderQuantityProducedMutation, ChangeWorkOrderQuantityProducedMutationVariables>({
      query: (variables) => ({ document: ChangeWorkOrderQuantityProducedDocument, variables })
    }),
    ChangeWorkOrderStatus: build.mutation<ChangeWorkOrderStatusMutation, ChangeWorkOrderStatusMutationVariables>({
      query: (variables) => ({ document: ChangeWorkOrderStatusDocument, variables })
    }),
    CountMaterialItem: build.mutation<CountMaterialItemMutation, CountMaterialItemMutationVariables>({
      query: (variables) => ({ document: CountMaterialItemDocument, variables })
    }),
    MoveMaterialItem: build.mutation<MoveMaterialItemMutation, MoveMaterialItemMutationVariables>({
      query: (variables) => ({ document: MoveMaterialItemDocument, variables })
    }),
    AdjustMaterialItem: build.mutation<AdjustMaterialItemMutation, AdjustMaterialItemMutationVariables>({
      query: (variables) => ({ document: AdjustMaterialItemDocument, variables })
    }),
    CreateMaterialItem: build.mutation<CreateMaterialItemMutation, CreateMaterialItemMutationVariables>({
      query: (variables) => ({ document: CreateMaterialItemDocument, variables })
    }),
    UpdateMaterialItemDetails: build.mutation<UpdateMaterialItemDetailsMutation, UpdateMaterialItemDetailsMutationVariables>({
      query: (variables) => ({ document: UpdateMaterialItemDetailsDocument, variables })
    }),
    CreateTag: build.mutation<CreateTagMutation, CreateTagMutationVariables>({
      query: (variables) => ({ document: CreateTagDocument, variables })
    }),
    SetMaterialItemTagSpec: build.mutation<SetMaterialItemTagSpecMutation, SetMaterialItemTagSpecMutationVariables>({
      query: (variables) => ({ document: SetMaterialItemTagSpecDocument, variables })
    }),
    CreateOrUpdateTagByTagCode: build.mutation<CreateOrUpdateTagByTagCodeMutation, CreateOrUpdateTagByTagCodeMutationVariables>({
      query: (variables) => ({ document: CreateOrUpdateTagByTagCodeDocument, variables })
    }),
    ActivateMaterialItem: build.mutation<ActivateMaterialItemMutation, ActivateMaterialItemMutationVariables>({
      query: (variables) => ({ document: ActivateMaterialItemDocument, variables })
    }),
    InactivateMaterialItem: build.mutation<InactivateMaterialItemMutation, InactivateMaterialItemMutationVariables>({
      query: (variables) => ({ document: InactivateMaterialItemDocument, variables })
    }),
    DeleteMaterialItem: build.mutation<DeleteMaterialItemMutation, DeleteMaterialItemMutationVariables>({
      query: (variables) => ({ document: DeleteMaterialItemDocument, variables })
    }),
    UndeleteMaterialItem: build.mutation<UndeleteMaterialItemMutation, UndeleteMaterialItemMutationVariables>({
      query: (variables) => ({ document: UndeleteMaterialItemDocument, variables })
    }),
    AssignMaterialItemToVendor: build.mutation<AssignMaterialItemToVendorMutation, AssignMaterialItemToVendorMutationVariables>({
      query: (variables) => ({ document: AssignMaterialItemToVendorDocument, variables })
    }),
    UnassignMaterialItemToVendor: build.mutation<UnassignMaterialItemToVendorMutation, UnassignMaterialItemToVendorMutationVariables>({
      query: (variables) => ({ document: UnassignMaterialItemToVendorDocument, variables })
    }),
    SetDefaultVendor: build.mutation<SetDefaultVendorMutation, SetDefaultVendorMutationVariables>({
      query: (variables) => ({ document: SetDefaultVendorDocument, variables })
    }),
    SetVendorMaterialCost: build.mutation<SetVendorMaterialCostMutation, SetVendorMaterialCostMutationVariables>({
      query: (variables) => ({ document: SetVendorMaterialCostDocument, variables })
    }),
    CreateCountAssignment: build.mutation<CreateCountAssignmentMutation, CreateCountAssignmentMutationVariables>({
      query: (variables) => ({ document: CreateCountAssignmentDocument, variables })
    }),
    ReassignCountAssignment: build.mutation<ReassignCountAssignmentMutation, ReassignCountAssignmentMutationVariables>({
      query: (variables) => ({ document: ReassignCountAssignmentDocument, variables })
    }),
    UnassignCountAssignment: build.mutation<UnassignCountAssignmentMutation, UnassignCountAssignmentMutationVariables>({
      query: (variables) => ({ document: UnassignCountAssignmentDocument, variables })
    }),
    StartAssignmentTask: build.mutation<StartAssignmentTaskMutation, StartAssignmentTaskMutationVariables>({
      query: (variables) => ({ document: StartAssignmentTaskDocument, variables })
    }),
    CompleteAssignmentTask: build.mutation<CompleteAssignmentTaskMutation, CompleteAssignmentTaskMutationVariables>({
      query: (variables) => ({ document: CompleteAssignmentTaskDocument, variables })
    }),
    SkipAssignmentTask: build.mutation<SkipAssignmentTaskMutation, SkipAssignmentTaskMutationVariables>({
      query: (variables) => ({ document: SkipAssignmentTaskDocument, variables })
    }),
    SetMaterialItemBatchTracking: build.mutation<SetMaterialItemBatchTrackingMutation, SetMaterialItemBatchTrackingMutationVariables>({
      query: (variables) => ({ document: SetMaterialItemBatchTrackingDocument, variables })
    }),
    SetMaterialItemImage: build.mutation<SetMaterialItemImageMutation, SetMaterialItemImageMutationVariables>({
      query: (variables) => ({ document: SetMaterialItemImageDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useChangeWorkOrderQuantityProducedMutation, useChangeWorkOrderStatusMutation, useCountMaterialItemMutation, useMoveMaterialItemMutation, useAdjustMaterialItemMutation, useCreateMaterialItemMutation, useUpdateMaterialItemDetailsMutation, useCreateTagMutation, useSetMaterialItemTagSpecMutation, useCreateOrUpdateTagByTagCodeMutation, useActivateMaterialItemMutation, useInactivateMaterialItemMutation, useDeleteMaterialItemMutation, useUndeleteMaterialItemMutation, useAssignMaterialItemToVendorMutation, useUnassignMaterialItemToVendorMutation, useSetDefaultVendorMutation, useSetVendorMaterialCostMutation, useCreateCountAssignmentMutation, useReassignCountAssignmentMutation, useUnassignCountAssignmentMutation, useStartAssignmentTaskMutation, useCompleteAssignmentTaskMutation, useSkipAssignmentTaskMutation, useSetMaterialItemBatchTrackingMutation, useSetMaterialItemImageMutation } = injectedRtkApi;
